var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header-warp" },
    [
      _c("div", { staticClass: "pc-header" }, [
        _c("div", { staticClass: "site-nav" }, [
          _c("div", { staticClass: "warp" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _c("i", { staticClass: "location-icon" }),
                _vm._v(" "),
                _c("span", { staticClass: "current-location" }, [
                  _vm._v(_vm._s(_vm.city_location.label || "保山"))
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "change-location-btn",
                    on: {
                      click: function($event) {
                        return _vm.openChangeLocation()
                      }
                    }
                  },
                  [_vm._v("[切换]")]
                ),
                _vm._v(" "),
                _c("router-link", { attrs: { to: "/" } }, [
                  _c("div", { staticClass: "gohome icon-home" }, [
                    _vm._v("首页")
                  ])
                ]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "gohome",
                      staticStyle: { "margin-left": "20px" },
                      on: { click: _vm.toPlatform }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.platformText) +
                          "\n            "
                      )
                    ]
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _vm.noticeList.length > 0
              ? _c("div", { staticClass: "notice" }, [
                  _c(
                    "div",
                    { staticClass: "noticeBox" },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "swiper",
                        {
                          staticClass: "noticeBox-swiper",
                          attrs: {
                            options: {
                              autoplay: true, // 可选选项，自动滑动
                              speed: 1000,
                              autoplay: {
                                delay: 5000,
                                stopOnLastSlide: false /* 触摸滑动后是否继续轮播 */,
                                disableOnInteraction: false
                              }
                            }
                          }
                        },
                        _vm._l(_vm.noticeList, function(item, index) {
                          return _c(
                            "swiper-slide",
                            {
                              key: index,
                              staticClass: "noticeBox-swiper-box",
                              on: {
                                click: function($event) {
                                  return _vm.goToDetail(item.noticeId)
                                }
                              }
                            },
                            [
                              _c(
                                "h3",
                                {
                                  staticClass:
                                    "medium overflow font-color-FF7 cur-poi",
                                  staticStyle: { "font-size": "14px" },
                                  on: {
                                    click: function($event) {
                                      return _vm.goToDetail(item.noticeId)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(item.noticeTitle) +
                                      "\n                "
                                  )
                                ]
                              )
                            ]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "right" },
              [
                _vm.userInfo.phone
                  ? _c("div", { staticClass: "userInfoMain" }, [
                      _c(
                        "div",
                        {
                          staticClass: "item item-select",
                          staticStyle: { padding: "0 20px", width: "200px" },
                          on: {
                            mouseover: function($event) {
                              _vm.isShowOut = true
                            },
                            mouseleave: function($event) {
                              _vm.isShowOut = false
                            },
                            click: _vm.goToUserInfo
                          }
                        },
                        [
                          _c("span", { staticClass: "hover-item" }, [
                            _c("span", { staticClass: "headImg" }, [
                              _vm.userInfo.headImage
                                ? _c("img", {
                                    staticStyle: { height: "100%" },
                                    attrs: {
                                      src: _vm.userInfo.headImage,
                                      alt: ""
                                    }
                                  })
                                : _c("img", {
                                    staticStyle: { height: "100%" },
                                    attrs: {
                                      src:
                                        "https://static.xhngyl.com/xhngyl-platform-gy/avatar/2021-08-24/4588b24faf4c4588a0878eeef5fcd4b3-avatar.png",
                                      alt: ""
                                    }
                                  })
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "item_text",
                                staticStyle: {
                                  display: "inline-block",
                                  width: "100px",
                                  overflow: "hidden",
                                  "text-overflow": "ellipsis",
                                  "white-space": "nowrap"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.userInfo.name
                                      ? _vm.userInfo.name
                                      : _vm.userInfo.account
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "ico-arrow el-icon-arrow-down"
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isShowOut,
                                  expression: "isShowOut"
                                }
                              ],
                              staticClass: "cart-box"
                            },
                            [
                              _c("div", { staticClass: "user-bar" }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      cursor: "pointer",
                                      display: "flex",
                                      "justify-content": "left"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.$router.push({
                                          name: "userInfo"
                                        })
                                      }
                                    }
                                  },
                                  [
                                    _c("span", { staticClass: "headImg" }, [
                                      _vm.userInfo.headImage
                                        ? _c("img", {
                                            staticStyle: { height: "100%" },
                                            attrs: {
                                              src: _vm.userInfo.headImage,
                                              alt: ""
                                            }
                                          })
                                        : _c("img", {
                                            staticStyle: { height: "100%" },
                                            attrs: {
                                              src: _vm.headImage,
                                              alt: ""
                                            }
                                          })
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "user-bar-name" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              width: "50px",
                                              overflow: "hidden",
                                              "text-overflow": "ellipsis",
                                              "white-space": "nowrap"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(
                                                  _vm.userInfo.name
                                                    ? _vm.userInfo.name
                                                    : _vm.userInfo.account
                                                ) +
                                                "\n                      "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "outLogin",
                                    on: { click: _vm.outLoginBtn }
                                  },
                                  [_c("span", [_vm._v(" 退出 ")])]
                                )
                              ]),
                              _vm._v(" "),
                              _c("ul", [
                                _c(
                                  "li",
                                  {
                                    staticClass: "icon-Personal-information",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.goToUserInfo.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    个人信息\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  {
                                    staticClass: "icon-xiaoxizhongxin",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.goToMessage.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    我的消息\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  {
                                    staticClass: "icon-The-order",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.goToUserOrder.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    我的订单\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  {
                                    staticClass: "icon-positioning",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.goToUserAddress.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    收货地址\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  {
                                    staticClass: "icon-collection-01",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.gotoUserCollection.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    我的收藏\n                  "
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        ]
                      )
                    ])
                  : _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "alien-items": "center"
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "header-login-btn",
                            on: {
                              click: function($event) {
                                return _vm.loginBtn(2)
                              }
                            }
                          },
                          [_vm._v("[请登录]")]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "header-register-btn",
                            staticStyle: {
                              "margin-right": "60px",
                              cursor: "pointer"
                            },
                            on: {
                              click: function($event) {
                                return _vm.loginBtn(1)
                              }
                            }
                          },
                          [_vm._v("[注册]")]
                        )
                      ]
                    ),
                _vm._v(" "),
                _c("div", { staticClass: "item" }, [
                  _c("i", { staticClass: "icon-The-order" }),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "hover-item",
                      on: { click: _vm.goToUserOrder }
                    },
                    [
                      _c("span", { staticClass: "item_text" }, [
                        _vm._v("我的订单")
                      ]),
                      _vm.orderTotal ? _c("span", [_vm._v("(")]) : _vm._e(),
                      _vm._v(" "),
                      _vm.orderTotal
                        ? _c("span", { staticStyle: { color: "#ff4747" } }, [
                            _vm._v(_vm._s(_vm.orderTotal))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.orderTotal ? _c("span", [_vm._v(")")]) : _vm._e()
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "item",
                    on: {
                      mouseover: function($event) {
                        _vm.isShowSecondMenu = true
                      },
                      mouseleave: function($event) {
                        _vm.isShowSecondMenu = false
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "icon-Application-in",
                      staticStyle: { "font-size": "16px" }
                    }),
                    _vm._v(" "),
                    _vm._m(1),
                    _vm._v(" "),
                    _vm.isShowSecondMenu
                      ? _c("div", { staticClass: "secondMenu" }, [
                          _c(
                            "div",
                            {
                              staticClass: "item1",
                              on: { click: _vm.getCollaborate }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("../../assets/images/setUpShop@2x.png"),
                                  alt: ""
                                }
                              }),
                              _vm._v(" "),
                              _c("div", [_vm._v("一键开店")])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "item2",
                              on: { click: _vm.getMerchantLogin }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("../../assets/images/loginShop@2x.png"),
                                  alt: ""
                                }
                              }),
                              _vm._v(" "),
                              _c("div", [_vm._v("登录企业中心")])
                            ]
                          )
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "item item-select" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "cart-box user-box",
                      staticStyle: {
                        width: "auto",
                        padding: "0",
                        right: "0",
                        left: "-122px"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "QR-container",
                          staticStyle: { padding: "20px" }
                        },
                        _vm._l(_vm.QR_code, function(item, index) {
                          return _c("div", { key: index }, [
                            _c("img", { attrs: { src: item.code, alt: "" } }),
                            _vm._v(" "),
                            _c("div", [
                              _c("img", { attrs: { src: item.icon, alt: "" } }),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(item.text))])
                            ])
                          ])
                        }),
                        0
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("router-link", { attrs: { to: "/helpCenter" } }, [
                  _c("div", { staticClass: "item" }, [
                    _c("span", { staticClass: "item_text" }, [
                      _vm._v("帮助中心")
                    ])
                  ])
                ])
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "fixed-help-box" }, [
          _c("div", { staticClass: "fixed-help-box-outer" }, [
            _c(
              "div",
              {
                staticClass: "fixed-help-box-item",
                on: { click: _vm.goToShopCart }
              },
              [
                _c("span", { staticClass: "icon-The-shopping-cart" }, [
                  _vm.isShowNum && _vm.cartNumber !== 0
                    ? _c("span", {
                        domProps: { textContent: _vm._s(_vm.cartNumber) }
                      })
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.platform == "b2c" ? "购物车" : "采购单"))
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "fixed-help-box-item",
                on: {
                  mouseover: function($event) {
                    _vm.showHelp = true
                  },
                  mouseout: function($event) {
                    _vm.showHelp = false
                  }
                }
              },
              [
                _c("span", { staticClass: "icon-The-phone" }),
                _vm._v(" "),
                _c("span", [_vm._v("客服热线")]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showHelp,
                        expression: "showHelp"
                      }
                    ],
                    staticClass: "online_help_box"
                  },
                  [_vm._m(4), _vm._v(" "), _vm._m(5)]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "fixed-help-box-item",
                on: {
                  mouseover: function($event) {
                    _vm.showServer = true
                  },
                  mouseout: function($event) {
                    _vm.showServer = false
                  }
                }
              },
              [
                _c("span", { staticClass: "icon-Customer-service-hotline" }),
                _vm._v(" "),
                _c("span", [_vm._v("平台客服")]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showServer,
                        expression: "showServer"
                      }
                    ],
                    staticClass: "online_help_box2"
                  },
                  [_vm._m(6), _vm._v(" "), _vm._m(7)]
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "提示", visible: _vm.outLoginDialog, width: "30%" },
          on: {
            "update:visible": function($event) {
              _vm.outLoginDialog = $event
            }
          }
        },
        [
          _c("span", [_vm._v("确定退出登录吗？")]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.outLoginDialog = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.outLogin } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "flexLeft", on: { click: _vm.toBack } }, [
        _c("p", { staticClass: "back" }, [_vm._v("返回上一页")]),
        _vm._v(" "),
        _c("i", { staticClass: "el-icon-download" })
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "noticeTitle" }, [
      _c("img", {
        attrs: { src: require("../../../static/image/notice.gif"), alt: "" }
      }),
      _vm._v(" "),
      _c("span", [_vm._v("通知公告:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "hover-item" }, [
      _c("span", { staticClass: "item_text" }, [_vm._v("企业中心")]),
      _vm._v(" "),
      _c("i", { staticClass: "ico-arrow el-icon-arrow-down" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item item-select" }, [
      _c("span", { staticClass: "hover-item" }, [
        _c("i", {
          staticClass: "icon-Customer-service-hotline",
          staticStyle: { "font-size": "20px" }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "item_text" }, [_vm._v("平台客服")]),
        _vm._v(" "),
        _c("i", { staticClass: "ico-arrow el-icon-arrow-down" })
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "cart-box user-box",
          staticStyle: { width: "440px", left: "-160px" }
        },
        [
          _c(
            "div",
            {
              staticClass: "online_help_box2",
              staticStyle: {
                display: "flex",
                "justify-content": "space-around",
                "align-items": "center",
                "flex-direction": "row"
              }
            },
            [
              _c("div", { staticStyle: { "text-align": "center" } }, [
                _c("img", {
                  staticStyle: { width: "150px", margin: "0 auto" },
                  attrs: {
                    src: require("../../assets/images/qrcode.png"),
                    alt: "",
                    srcset: ""
                  }
                }),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticStyle: {
                      "text-align": "center",
                      color: "#000000",
                      "font-size": "14px"
                    }
                  },
                  [
                    _vm._v(
                      "\n                    扫码联系微信客服-牛牛\n                  "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticStyle: { "text-align": "center" } }, [
                _c("img", {
                  staticStyle: { width: "150px", margin: "0 auto" },
                  attrs: {
                    src: require("../../assets/images/qrcode2.png"),
                    alt: "",
                    srcset: ""
                  }
                }),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticStyle: {
                      "text-align": "center",
                      color: "#000000",
                      "font-size": "14px"
                    }
                  },
                  [
                    _vm._v(
                      "\n                    扫码联系微信客服-链链\n                  "
                    )
                  ]
                )
              ])
            ]
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "hover-item" }, [
      _c("i", {
        staticClass: "icon-Mobile-phone",
        staticStyle: { "font-size": "20px" }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "item_text" }, [_vm._v("移动端")]),
      _vm._v(" "),
      _c("i", { staticClass: "ico-arrow el-icon-arrow-down" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "imgbox" }, [
      _c("img", {
        attrs: {
          src: require("../../assets/images/online_help.png"),
          alt: "",
          srcset: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text" }, [
      _c("p", [_vm._v("企业客服")]),
      _vm._v(" "),
      _c("span", [_vm._v("上班时间: 9:00 ~ 18:00")]),
      _vm._v(" "),
      _c("span", [_vm._v("客服热线 400-082-3688")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        staticStyle: { width: "150px" },
        attrs: {
          src: require("../../assets/images/qrcode.png"),
          alt: "",
          srcset: ""
        }
      }),
      _vm._v(" "),
      _c(
        "p",
        {
          staticStyle: {
            "text-align": "center",
            color: "#000000",
            "font-size": "14px"
          }
        },
        [_vm._v("\n                扫码联系微信客服-牛牛\n              ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        staticStyle: { width: "150px" },
        attrs: {
          src: require("../../assets/images/qrcode2.png"),
          alt: "",
          srcset: ""
        }
      }),
      _vm._v(" "),
      _c(
        "p",
        {
          staticStyle: {
            "text-align": "center",
            color: "#000000",
            "font-size": "14px"
          }
        },
        [_vm._v("\n                扫码联系微信客服-链链\n              ")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-1844a7a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-1844a7a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/base/siteNav.vue
// module id = null
// module chunks = 